import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Plans from './pages/Plans';
import Models from './pages/Models';
import MCP from './pages/MCP';
import SpeechSynthesis from './pages/SpeechSynthesis';
import Feedback from './pages/Feedback';
import Logs from './pages/Logs';
import StripeSettings from './pages/StripeSettings';
// import Blog from './pages/Blog'; // Replaced by BlogManagement
import Blog from './pages/Blog';
import BlogManagement from './pages/BlogManagement';
import BlogCreate from './pages/BlogCreate';
import BlogEdit from './pages/BlogEdit';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path="/plans"
            element={
              <PrivateRoute>
                <Plans />
              </PrivateRoute>
            }
          />
          <Route
            path="/models"
            element={
              <PrivateRoute>
                <Models />
              </PrivateRoute>
            }
          />
          <Route
            path="/mcp"
            element={
              <PrivateRoute>
                <MCP />
              </PrivateRoute>
            }
          />
          <Route
            path="/speech-synthesis"
            element={
              <PrivateRoute>
                <SpeechSynthesis />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <PrivateRoute>
                <Feedback />
              </PrivateRoute>
            }
          />
          <Route
            path="/stripe"
            element={
              <PrivateRoute>
                <StripeSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/blog"
            element={
              <PrivateRoute>
                <Blog />
              </PrivateRoute>
            }
          />
          <Route
            path="/blog/create"
            element={
              <PrivateRoute>
                <BlogCreate />
              </PrivateRoute>
            }
          />
          <Route
            path="/blog/management"
            element={
              <PrivateRoute>
                <Blog />
              </PrivateRoute>
            }
          />
          <Route
            path="/blog/edit/:id"
            element={
              <PrivateRoute>
                <BlogEdit />
              </PrivateRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <PrivateRoute>
                <Logs />
              </PrivateRoute>
            }
          />

          {/* Redirect all other routes to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
